import React from 'react';
import InputField from '../components/InputField';
import styles from '../capitalExpenditure.module.scss';

const FirstQuarter = ({ 
  row, 
  viewMode, 
  handleInputChange, 
  handleOperationalRowChange, 
  isOperational = false 
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  
  return (
    <>
      {/* Quarter 1 Columns */}
      <td className={styles.budgetCell}>
        <InputField
          value={row.q1BudgetDemand}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q1BudgetDemand', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q1BudgetExpenditure}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q1BudgetExpenditure', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q1AuthorityReceived}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q1AuthorityReceived', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q1Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q1Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q1RemainingBalance}
          placeholder="0"
          readOnly={true}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
    </>
  );
};

export default FirstQuarter;
